<template>
  <div>
    <div class="d-flex justify-content-between">
      <h1 class="page-header">{{ $t('dealerDiscount.pageTitle') }}</h1>
      <ts-breadcrumb
        :items="[
          { text: $t('home'), href: '/' },
          {
            text: $t('dealerDiscount.pageTitle'),
            active: true
          }
        ]"
      />
    </div>
    <ts-card>
      <ts-card-wrapper>
        <div class="d-flex justify-content-between">
          <div class="ts-flex ts-space-x-3">
            <ts-button outline color="info" @click.prevent="addNew">{{
              $t('add_new')
            }}</ts-button>
          </div>
          <div class="d-flex ts-space-x-3 ts-items-center">
            <ts-input
              v-model="search"
              v-tooltip="$t('dealerDiscount.search')"
              :placeholder="$t('search')"
              style="width: 250px"
              class="inline-block"
            />
          </div>
        </div>
      </ts-card-wrapper>
      <ts-table
        :columns="columns"
        :records="resources"
        :loading="loading"
        :rowGroup="{
          field: 'dealer_type'
        }"
      >
        <template v-slot="{ record }">
          <td>{{ record.barcode }}</td>
          <td>{{ record.pro_group_name_en }}</td>
          <td>{{ record.product_name_en }}</td>
          <td class="text-right">
            {{ record.discount_rate }} {{ record.discount_type }}
          </td>
          <td class="ts-text-center">
            <a-popconfirm
              placement="leftTop"
              :title="$t('are_you_sure_to_delete')"
              :ok-text="$t('yes')"
              :cancel-text="$t('no')"
              @confirm="deleteRecord(record)"
            >
              <a href="#" :disabled="record._deleting">
                <i class="fas fa-circle-notch spin" v-if="record._deleting"></i>
                <i class="fa fa-trash text-red" v-else></i>
              </a>
            </a-popconfirm>
          </td>
        </template>
      </ts-table>
      <div class="d-flex justify-content-end p-15">
        <ts-pagination
          v-model="pagination"
          @navigate="fetchData"
        ></ts-pagination>
      </div>
    </ts-card>
  </div>
</template>

<script>
import { debounce } from 'lodash'
import { mapState } from 'vuex'
import { Errors } from 'form-backend-validation'

export default {
  name: 'dealerDiscount',
  data() {
    return {
      errors: new Errors(),
      loading: false,
      product_location_loading: false
    }
  },
  computed: {
    ...mapState('product/dealerDiscount', ['resources', 'pagination']),
    search: {
      get() {
        return this.$store.state.product.dealerDiscount.search
      },
      set(newValue) {
        this.$store.commit('product/dealerDiscount/SET_SEARCH', newValue)
        this.$store.commit('product/dealerDiscount/RESET_CURRENT_PAGE')
      }
    },
    columns() {
      return [
        { name: this.$t('dealerDiscount.barcode') },
        { name: this.$t('dealerDiscount.productGroup') },
        { name: this.$t('dealerDiscount.productNameEn') },
        {
          name: this.$t('dealerDiscount.discount'),
          style: 'text-align:right;'
        },
        { name: this.$t('actions'), style: 'text-align:center; width:80px' }
      ]
    }
  },
  methods: {
    fetchData(attributes) {
      this.loading = true
      this.$store
        .dispatch('product/dealerDiscount/fetch', { ...attributes })
        .then(() => {
          this.loading = false
        })
        .catch(error => {
          this.loading = false
          this.$toasted.error(error.message)
        })
    },
    addNew() {
      this.$router.push({ name: 'dealer-discount-create' })
    },
    branchFilter(value) {
      this.$store.commit('product/dealerDiscount/SET_BRANCH_ID', value)
      this.fetchData()
    },
    deleteRecord(record) {
      record._deleting = true
      this.$store
        .dispatch('product/dealerDiscount/destroy', {
          dealer_type_id: record.dealer_type_id,
          product_id: record.product_id,
          uom_id: record.uom_id
        })
        .then(response => {
          this.$toasted.success(response.message)
          this.fetchData()
        })
        .catch(error => {
          this.$toasted.error(error.message)
        })
        .finally(() => {
          record._deleting = false
        })
    }
  },
  watch: {
    search: debounce(function() {
      this.fetchData()
    }, 500)
  },
  beforeRouteLeave(to, from, next) {
    this.$store.commit('product/dealerDiscount/RESET_STATE')
    next()
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.fetchData()
    })
  }
}
</script>
